/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class MessagesListMessageComponent extends Component {
  @service twoWayChat;
}
